import { render, staticRenderFns } from "./DocumentsAll.vue?vue&type=template&id=281e5906&scoped=true"
import script from "./DocumentsAll.vue?vue&type=script&lang=js"
export * from "./DocumentsAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e5906",
  null
  
)

export default component.exports